import React from 'react';
import styled from 'styled-components';
import {BodyContainer} from "../Container/Container";
import {CardTitle} from "../Kit/Kit";
import Link from "gatsby-link";

const OtherContainer = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  grid-gap: 24px;
  margin-top: 24px;
  
  @media(min-width: 768px){
    grid-template-columns: repeat(4, 1fr);
  }
  
  @media(min-width: 992px) {
    margin-top: 50px;
  }
`;

const SingleProductContainer = styled.div`
  position: relative;
  :hover .overlay{
    opacity: .8;
  }
`;

const ProductImg = styled.img`
  display: block;
  width: 100%;
  height: auto;
`;

const ProductOverlay = styled.div`
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  height: 100%;
  width: 100%;
  opacity: 0;
  transition: .3s ease;
  background-color: #2d98ba;
  display: flex;
  justify-content: center;
  align-items: center;
  border: 5px solid #90d2e4;
  box-sizing: border-box;
  cursor: pointer;
`;

const OverlayText = styled.div`
  color: #0090bf;
  background: #fff;
  text-align: center;
  font-family: Cabin-Bold, sans-serif;
  font-size: 14px;
  padding: 15px 10px;
  width: 100px;

  @media(min-width: 776px) {
    font-size: 12px;
    width: 80px;
  }
  
  @media(min-width: 992px) {
    font-size: 16px;
    width: 100px;
    padding: 15px 20px;
  }
  
  @media(min-width: 1200px) {
    //font-size: 30px;
    padding: 20px 30px;
  }
  
  @media(min-width: 1680px) {
    width: 200px;
    font-size: 30px;
  }
`;

const OtherProducts = (props) => {
    const {data} = props;
    return (
      <BodyContainer>
          <CardTitle>Check out our Other Products</CardTitle>
          <OtherContainer>
              {data.map(i => {
                  return (
                    <Link to={i.slug} title={`Read More About H & N Group's Wholesale ${i.title}`}>
                        <SingleProductContainer>
                            <ProductImg
                              src={i.source_url}
                              alt={i.alt_text}
                            />
                            <ProductOverlay className='overlay'>
                                <OverlayText>{i.title}</OverlayText>
                            </ProductOverlay>
                        </SingleProductContainer>
                    </Link>
                  )
              })}
          </OtherContainer>
      </BodyContainer>
    );
};

export default OtherProducts;



// WEBPACK FOOTER //
// ./src/components/SingleProduct/OtherProducts.js